import { motion } from "framer-motion";

const ABOUT_IMG = "/jobs/job-1273.webp";

const chapters = [
  {
    n: "01",
    title: "Reliable & local",
    body: "Based in Washington and serving the wider North East, we turn up when we say we will and leave every site sharp. High-quality ground maintenance for homes, businesses and public open spaces.",
  },
  {
    n: "02",
    title: "Eco-conscious approach",
    body: "Clean, healthy, professionally maintained outdoor areas — all year round. We work considerately and keep your grounds looking their best through every season.",
  },
  {
    n: "03",
    title: "Fully insured & fair",
    body: "A friendly, experienced and fully insured team offering competitive pricing. From a single visit to a regular maintenance plan, the job is always done properly.",
  },
];

const reveal = {
  hidden: { opacity: 0, y: 40 },
  show: { opacity: 1, y: 0, transition: { duration: 0.7, ease: [0.22, 1, 0.36, 1] } },
};

export const About = () => {
  return (
    <section id="about" className="relative bg-brand-ink py-24 md:py-36">
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <motion.div
          variants={reveal}
          initial="hidden"
          whileInView="show"
          viewport={{ once: true, margin: "-80px" }}
          className="flex items-center gap-3 mb-6"
        >
          <span className="h-px w-12 bg-brand-orange" />
          <span className="text-xs md:text-sm tracking-[0.25em] uppercase font-heading text-brand-orange">
            About Clarkes GroundCare
          </span>
        </motion.div>

        <motion.h2
          variants={reveal}
          initial="hidden"
          whileInView="show"
          viewport={{ once: true, margin: "-80px" }}
          className="font-heading font-medium tracking-tight text-white text-4xl md:text-6xl max-w-3xl leading-[1.05]"
        >
          Reliable. Local. <span className="text-brand-orange">Affordable.</span>
        </motion.h2>

        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 mt-16 items-start">
          <div className="lg:col-span-6 space-y-10">
            {chapters.map((c, i) => (
              <motion.div
                key={c.n}
                variants={reveal}
                initial="hidden"
                whileInView="show"
                viewport={{ once: true, margin: "-60px" }}
                transition={{ delay: i * 0.08 }}
                className="flex gap-6 border-t border-white/10 pt-6"
              >
                <span className="font-display text-brand-orange text-4xl leading-none">{c.n}</span>
                <div>
                  <h3 className="font-heading text-white text-xl md:text-2xl mb-2">{c.title}</h3>
                  <p className="text-white/60 font-body leading-relaxed">{c.body}</p>
                </div>
              </motion.div>
            ))}
          </div>

          <motion.div
            variants={reveal}
            initial="hidden"
            whileInView="show"
            viewport={{ once: true, margin: "-80px" }}
            className="lg:col-span-6 relative"
          >
            <div className="relative overflow-hidden">
              <img
                src={ABOUT_IMG}
                alt="Professional ground maintenance worker"
                className="w-full h-[420px] md:h-[560px] object-cover transition-transform duration-700 hover:scale-[1.02]"
              />
              <div className="absolute inset-0 ring-1 ring-inset ring-white/10" />
            </div>
            <div className="absolute -bottom-6 -left-4 md:left-6 bg-brand-orange px-6 py-5">
              <p className="font-display text-white text-3xl md:text-4xl leading-none">Mon–Sun</p>
              <p className="text-white/90 text-xs tracking-widest uppercase mt-1">Working days</p>
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
};
